import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Domain } from "../model/model";
@Injectable()
export class DomainService {
  public queryEndPoint = "query-api/Domain";
  constructor(private http: HttpClient) {}

  get = () => this.http.get<Domain[]>(`${this.queryEndPoint}`);
}
